import type { DmMessagePatientRow } from '../../../services/dmMessagesInbox';

export interface MessageTableRow {
    id: string;
    patient: DmMessagePatientRow;
    leaving: boolean;
}

// Keyed by the latest message too, so a patient who writes again after a review shows again.
export function messageLeaveKey(row: DmMessagePatientRow): string {
    return `${row.patientId}:${row.latestMessage.id}`;
}

export function buildMessageRows(
    patients: readonly DmMessagePatientRow[],
    leavingKeys: ReadonlySet<string>,
    hiddenKeys: ReadonlySet<string>
): MessageTableRow[] {
    return patients
        .filter((patient) => !hiddenKeys.has(messageLeaveKey(patient)))
        .map((patient) => ({
            id: patient.patientId,
            patient,
            leaving: leavingKeys.has(messageLeaveKey(patient))
        }));
}
